export default __webpack_public_path__ + "static/media/151-fireplace.53232b1a.png";